module.exports = __webpack_public_path__ + "img/lv_success_3.47b0aac0.png";